export default __webpack_public_path__ + "static/media/error-graphic@2x.7e2f9870.png";